import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ManageCampaign from './ManageCampaign';
import OutReachCampaign from './OutreachCampaign';
import ViewCampaigns from './ViewCampaigns';
class TeamSettings extends Component {
    constructor() {
        super();
        this.state = {
            projectId: null,
            hideBotStore: false
        }
    }
    componentDidMount() {

        (function () {
            var currentPath = window.location.href;
            var currentPath = window.location.href;
            var path = window.origin + "/sales-desk/projectmgmt/out-reach-campaign";
            var path1 = window.origin + "/sales-desk/projectmgmt/out-reach-campaign/";
            if (currentPath == path || currentPath == path1) {
                $("#create-new-campaign").addClass('active');
            } else if (currentPath.includes("/projectmgmt/out-reach-campaign") ||
                currentPath.includes("/projectmgmt/out-reach-campaign/")) {
                $("#manage-campaign").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-team-data-tab")).addClass('active')
            }
            $("#create-new-campaign,#manage-campaign")
                .on("click", function () {
                    $("#create-new-campaign,#manage-campaign")
                        .removeClass('active');
                    localStorage.setItem("last-team-data-tab", $(this)[0].id);
                    $(this).addClass('active')

                })


        })();
    }

    render() {
        return (

            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    {/* <div className="content-header" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5">
                                    <h1 className="m-0 page-title" >Settings</h1>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class">

                            <ul className="nav nav-tabs border-bottom navCluster">

                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/out-reach-campaign" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="create-new-campaign" style={{ marginRight: '15px' }}>
                                        Create New
                                    </li></Link>
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/out-reach-campaign/manage-campaign" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="manage-campaign" style={{ marginRight: '15px' }}>
                                        Manage campaign
                                    </li></Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/out-reach-campaign/manage-campaign/view-campaign-leads" component={ViewCampaigns}></Route>
                    <Route path="/projectmgmt/out-reach-campaign/manage-campaign" component={ManageCampaign}></Route>
                    <Route path="/projectmgmt/out-reach-campaign" component={OutReachCampaign}></Route>
                </Switch>
            </div>

        );
    }
}
export default TeamSettings;




// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/CampaignTabSettings.js